module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/icon-external-link.svg";